const params = (): URLSearchParams => new URLSearchParams(window.location.search);

/**
 * Cross-domain remember-me is opt-in: it stays off (first-party-only behaviour) unless the widget
 * SDK explicitly enables it with `?cross-domain-remember-me=on` after the merchant consents.
 */
export const isCrossDomainRememberMeEnabled = (): boolean =>
  params().get('cross-domain-remember-me') === 'on';
